"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSMSReceiversList = exports.useSendSMSList = exports.postExcelUpload = exports.postDeleteSendSMS = exports.postRegistSendSMS = exports.postModifySendSMS = void 0;
const account_1 = require("../../features/base/account");
const classes_1 = require("../../features/base/classes");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
const getSendSMS = async (queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/messages?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
const getSMSReceivers = async (queryString) => {
    const id = queryString.split('=')[1];
    const url = `/api/mimac/v1/messages/${id}/receivers`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
const postModifySendSMS = async (data) => {
    const url = `/api/mimac/v1/messages/${data.id}/update`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props),
    });
};
exports.postModifySendSMS = postModifySendSMS;
const postRegistSendSMS = async (data) => {
    const url = `/api/mimac/v1/messages`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ class_id: (0, classes_1.getClassesId)(), ...data }),
    });
};
exports.postRegistSendSMS = postRegistSendSMS;
const postDeleteSendSMS = async (id) => {
    const url = `/api/mimac/v1/messages/${id}/delete`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.postDeleteSendSMS = postDeleteSendSMS;
//메시지 수신자 엑셀 업로드
const postExcelUpload = async (file) => {
    //const queryString = objectToQueryString(data);
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/messages/upload-excel?&class_id=${class_id}`;
    const formData = new FormData();
    formData.append('file', file);
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        body: formData,
    });
};
exports.postExcelUpload = postExcelUpload;
//SMS 발송 리스트 조회
const useSendSMSList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`send_sms`, data], () => getSendSMS(queryString));
};
exports.useSendSMSList = useSendSMSList;
//SMS 수신자 조회
const useSMSReceiversList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`send_sms_receivers`, data], () => getSMSReceivers(queryString));
};
exports.useSMSReceiversList = useSMSReceiversList;
// export const useExcelDownload = () => {
// 	//const queryString = objectToQueryString(data);
// 	return useCustomQuery([`excel_download`], () => getExcelDownload());
// };
